import { render, staticRenderFns } from "./language-selector.vue?vue&type=template&id=802f26ea&scoped=true&"
import script from "./language-selector.vue?vue&type=script&lang=ts&"
export * from "./language-selector.vue?vue&type=script&lang=ts&"
import style0 from "./language-selector.vue?vue&type=style&index=0&id=802f26ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802f26ea",
  null
  
)

export default component.exports